export default __webpack_public_path__ + "static/media/confirmation message.c9914f46.png";